<script setup lang="ts">
import {computed} from 'vue'
import {useCompanyStore} from '../../stores/company'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'
import RBButton from '../Button.vue'
import {storeToRefs} from 'pinia'

const MAX_CHARACTER = 30

interface Props {
  variant?: 'normal' | 'invert'
}

const companyStore = useCompanyStore()
const {name: hotelName} = storeToRefs(companyStore)
const isNewUiEnabled = useNewUiEnabled()

const props = withDefaults(defineProps<Props>(), {
  variant: 'normal',
})

const isTextXs = computed(() => hotelName.value && hotelName.value.length > MAX_CHARACTER)

const buttonClasses = computed(() => ({
  'flex flex-row items-center': props.variant === 'normal',
  'flex flex-row-reverse items-center': props.variant === 'invert',
  'gap-x-3': isNewUiEnabled.value,
  'justify-end': isNewUiEnabled.value && props.variant === 'invert',
}))

const hotelNameClasses = computed(() => ({
  'text-base flex line-clamp-2 max-w-full': true,
  'leading-normal': isNewUiEnabled.value,
  'text-xs': props.variant === 'normal' && isTextXs.value,
  'text-right': props.variant === 'normal',
  'text-left': props.variant === 'invert',
}))
</script>

<template>
  <button :class="buttonClasses">
    <RBButton
      :class="[
        isNewUiEnabled ? '!px-0 !text-new-neutral-0' : '',
        isNewUiEnabled && props.variant === 'invert' ? '!w-auto' : '!w-full',
      ]"
      slim
      variant="custom"
    >
      <div :class="hotelNameClasses">
        <span>{{ hotelName }}</span>
      </div>
    </RBButton>

    <div class="flex items-center justify-center" :class="{'!w-10 !h-10 bg-white shadow-md rounded-full': !isNewUiEnabled}">
      <i
        class="fa-solid fa-hotel"
        :class="isNewUiEnabled ? 'text-new-neutral-0 text-[24px] leading-none' : 'text-gray-600 text-lg'"
      ></i>
    </div>
  </button>
</template>
